/**
 * 더미 데이터 설정 (예시)
 *
 * 실제 파일 src/config/dummyDataConfig.js 는 .gitignore 되어 저장소에 없습니다.
 * 로컬에서 프론트를 실행하려면 이 파일을 복사해서 사용하세요:
 *
 *   (mac/linux) cp src/config/dummyDataConfig.example.js src/config/dummyDataConfig.js
 *   (windows)   copy src\config\dummyDataConfig.example.js src\config\dummyDataConfig.js
 *
 * 아래 stub 은 모든 키에 대해 false 를 반환 → 실제 백엔드 API 를 사용합니다.
 * 특정 기능만 더미로 쓰고 싶으면 객체에 `키: true` 를 추가하세요.
 * (원본 설정이 있다면 업체에서 받은 dummyDataConfig.js 를 그대로 쓰면 됩니다.)
 */
export const useDummyDataConfig = new Proxy(
  {
    // 예) dashboardStats: true,  // 대시보드 통계만 더미 사용
  },
  {
    get: (target, prop) => (prop in target ? target[prop] : false),
  }
);

export default useDummyDataConfig;
